<template>
  <div class="row">
    <div class="advanced-search width-100">
      <form class="form-horizontal">
        <div class="fix-search-container"></div>
          <div class="form-group">
          <div class="row form-group">
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.city" @change="rememberCityChanged">City</el-checkbox>
              <el-autocomplete
                style="width:100%"
                class="inline-input"
                :debounce="150"
                ref="city"
                name="city"
                v-model="localCity"
                @keyup.enter.native="maybeSearchSubmit"
                clearable
                :fetch-suggestions="findCities"
                :trigger-on-focus="false"
                value-key="name"
                placeholder="City"
                @blur="verifyCityAutocompleteSelected"
                v-validate="modelValidations.localCity"
                data-vv-name="city"
                @select="setCityLoadCountiesZips">
              </el-autocomplete>
              <small class="text-danger" v-show="errors.has('city')">
                {{ getError('city') }}
              </small>
              <small class="text-danger" v-show="showInvalidAutocompleteWarning('city')">
                {{ fieldNotValidError('City') }}
              </small>
            </div>
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.streetNumber">Street Number</el-checkbox>
              <el-input type="search"
                        v-model="query.streetNumber"
                        @blur="maybeSearchSubmit"
                        clearable
                        placeholder="Street Number"
                        v-validate="modelValidations.queryStreetNumber"
                        data-vv-name="streetNumber"
                        data-vv-as="street number" />
              <small class="text-danger" v-show="errors.has('streetNumber')">
                {{ getError('streetNumber') }}
              </small>
            </div>
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.streetName" @change="alsoRememberCity">Street Name</el-checkbox>
              <el-autocomplete
                style="width:100%"
                name="streetName"
                class="inline-input"
                :debounce="150"
                ref="streetName"
                v-model="localStreetName"
                @keyup.enter.native="maybeSearchSubmit"
                clearable
                :fetch-suggestions="findStreets"
                :trigger-on-focus="false"
                value-key="name"
                placeholder="Street Name"
                @blur="verifyStreetAutocompleteSelected"
                v-validate="modelValidations.localStreetName"
                data-vv-name="streetName"
                data-vv-as="street name"
                @focus="verifyCitySelected"
                @select="setStreet">
              </el-autocomplete>
              <small class="text-danger" v-show="errors.has('streetName')">
                {{ getError('streetName') }}
              </small>
              <small class="text-danger" v-show="showInvalidAutocompleteWarning('streetName')">
                {{ fieldNotValidError('Street Name') }}
              </small>
            </div>
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.county" @change="alsoRememberCity">County</el-checkbox>
              <el-select class="select"
                         size="large"
                         clearable
                         placeholder="County"
                         @focus="verifyCitySelected"
                         @keyup.enter.native="searchSubmit"
                         data-vv-name="county"
                         v-model="query.county">
                <el-option v-for="option in counties"
                           class="select"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                </el-option>
              </el-select>
            </div>
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.state">State</el-checkbox>
              <el-select class="select"
                         name="state"
                         size="large"
                         clearable
                         placeholder="State"
                         v-model="query.state"
                         data-vv-name="state">
                <el-option v-for="option in states"
                           class="select"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.buildingNumber">Building Number</el-checkbox>
              <el-input type="search"
                        v-model="query.buildingNumber"
                        placeholder="Building Number"
                        @keyup.enter.native="searchSubmit"
                        data-vv-name="buildingNumber"
                        clearable/>
            </div>
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.floorNumber">Floor Number</el-checkbox>
                <el-input type="search"
                          v-model="query.floorNumber"
                          placeholder="Floor Number"
                          @keyup.enter.native="searchSubmit"
                          data-vv-name="floorNumber"
                          clearable/>
            </div>
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.suiteNumber">Suite Number</el-checkbox>
              <el-input type="search"
                        v-model="query.suiteNumber"
                        @keyup.enter.native="searchSubmit"
                        clearable
                        placeholder="Suite Number"
                        data-vv-name="suiteNumber"/>
            </div>
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.zip" @change="alsoRememberCity">Zip</el-checkbox>
              <el-select class="select"
                         name="zip"
                         maxlength="5"
                         size="large"
                         placeholder="Zip"
                         clearable
                         @keyup.enter.native="searchSubmit"
                         @focus="verifyCitySelected"
                         data-vv-name="zip"
                         v-model="query.zip">
                <el-option v-for="option in zipCodes"
                           class="select"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                </el-option>
              </el-select>
            </div>
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.jurisdiction">Jurisdiction</el-checkbox>
              <el-select class="select"
                         name="jurisdiction"
                         size="large"
                         clearable
                         @keyup.enter.native="searchSubmit"
                         placeholder="Jurisdiction"
                         v-model="query.jurisdiction"
                         data-vv-name="jurisdiction">
                <el-option v-for="option in constants.JURISDICTIONS"
                           class="select"
                           :value="option.value"
                           :label="option.label"
                           :key="option.label">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.lotNumber">Lot Number</el-checkbox>
              <el-input type="search"
                        v-model="query.lotNumber"
                        @keyup.enter.native="searchSubmit"
                        clearable
                        placeholder="Lot Number"
                        data-vv-name="lotNumber"/>
            </div>
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.blockNumber">Block Number</el-checkbox>
              <el-input type="search"
                        v-model="query.blockNumber"
                        @keyup.enter.native="searchSubmit"
                        placeholder="Block Number"
                        data-vv-name="blockNumber"
                        clearable/>
            </div>
            <div class="col-md-2">
              <el-checkbox class="remember-address-field" v-model="remember.phase">Phase</el-checkbox>
              <el-input type="search"
                        v-model="query.phase"
                        @keyup.enter.native="searchSubmit"
                        clearable
                        placeholder="Phase"
                        data-vv-name="phase"/>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer" style="padding-right: 0; width: 100%;">
      <div class="pull-right">
        <button type="button" class="btn btn-fill btn-info btn-company-search btn-clear" @click="clearForm">
          Clear
        </button>
        <button type="button" class="btn btn-fill btn-info" @click="searchSubmit">
          Search
        </button>
      </div>
    </div>
    <div class="fix-search-container"></div><!-- end card -->
    <div class="row">
      <div class="col-sm-12">
        <el-table class="table-striped wrap-whole-words"
                  :data="this.tableData"
                  border
                  @current-change="handleProjectSelect">
          <el-table-column width="50">
            <template v-slot="props">
              <div style="text-align: center" v-if="isSelectedProject(props.row)">
                <img style="max-width: 20px;" src="static/img/icon-checkmark.png" :title="'Selected Project: ' + props.row._source.name" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="Project Name"
              min-width="180"
              sortable
              :sort-method="(a, b) => callStringSort(a._source, b._source, 'name')"
              prop="_source.name">
            <template v-slot="props">
              {{ props.row._source.name }}
            </template>
          </el-table-column>
          <el-table-column
              label="Type"
              min-width="100"
              sortable
              prop="_source.projectType">
            <template v-slot="props">
              {{ props.row._source.projectType }}
            </template>
          </el-table-column>
          <el-table-column
              label="Building #"
              min-width="110"
              sortable
              :sort-method="(a, b) => callNumberInStringSort(a._source.address, b._source.address, 'buildingNumber')"
              prop="_source.address.buildingNumber">
            <template v-slot="props">
              {{ props.row._source.address.buildingNumber }}
            </template>
          </el-table-column>
          <el-table-column
              label="Floor #"
              min-width="90"
              sortable
              :sort-method="(a, b) => callNumberInStringSort(a._source.address, b._source.address, 'floorNumber')"
              prop="_source.address.floorNumber">
            <template v-slot="props">
              {{ props.row._source.address.floorNumber }}
            </template>
          </el-table-column>
          <el-table-column
              label="Suite #"
              min-width="80"
              sortable
              :sort-method="(a, b) => callNumberInStringSort(a._source.address, b._source.address, 'suiteNumber')"
              prop="_source.address.suiteNumber">
            <template v-slot="props">
              {{ props.row._source.address.suiteNumber }}
            </template>
          </el-table-column>
          <el-table-column
            label="Street #"
            min-width="100"
            sortable
            :sort-method="(a, b) => callNumberInStringSort(a._source.address, b._source.address, 'streetNumber')"
            prop="_source.address.streetNumber">
          <template v-slot="props">
            {{ props.row._source.address.streetNumber }}
          </template>
          </el-table-column>
          <el-table-column
              label="Street"
              min-width="100"
              sortable
              prop="_source.address.streetName">
            <template v-slot="props">
              {{ props.row._source.address.streetName }}
            </template>
          </el-table-column>
          <el-table-column
              label="City"
              min-width="80"
              sortable
              prop="_source.address.city">
            <template v-slot="props">
              {{ props.row._source.address.city }}
            </template>
          </el-table-column>
          <el-table-column
              min-width="110"
              label="Work Stopped">
            <template v-slot="props">
              <span v-if="props.row._source.stopWork">{{ props.row._source.stopWork | printBool }}</span>
              <span v-else>{{ props.row._source.stopWork | printBool }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
        <div class="col-sm-6 pagination-info">
          <span class="category">Showing {{total}} entries</span>
        </div>
      </div>
  </div>
</template>

<script>
import PProgress from 'src/components/UIComponents/Progress.vue'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import PButton from 'src/components/UIComponents/Button.vue'
import Constants from 'src/utilities/constants'
import {
  autocompleteTextButNoValue,
  autocompleteTextButNoValueMessage,
  findCities,
  findStreets,
  kvpsForSelectFromArray,
  maxResultsWarning,
  notifyWarning,
  numberInStringSort,
  setCityLoadCountiesZips,
  stringSort,
  verifyAutocompleteSelected
} from 'src/utilities/utils'
import {mapGetters} from 'vuex'
import {sync} from 'vuex-pathify'
import {OK} from 'http-status-codes'

  export default {
    components: {
      PProgress,
      PButton,
      PSwitch
    },
    computed: {
      query: sync('projects/searchWizard@query'),
      remember: sync('projects/searchWizard@remember'),
      ...mapGetters({
        activeModals: 'modalTracker/activeModals',
        states: 'states',
        tableData: 'projects/searchWizard/quickProjectResults'
      }),
      total() {
        return this.tableData.length
      },
      canEdit() {
        return this.$can('edit', Permissions.PROJECTS)
      },
      canSearch() {
        return this.$can('read', Permissions.PROJECTS)
      }
    },
    data() {
      return {
        constants: Constants,
        localCity: null,
        localStreetName: null,
        counties: [],
        zipCodes: [],
        modelValidations: {
          localCity: {
            required: true
          },
          queryStreetNumber: {
            required: true
          },
          localStreetName: {
            required: true
          }
        },
        checkedColumnStyle: {
          padding: 0
        },
        selectedProject: null
      }
    },
    methods: {
      showInvalidAutocompleteWarning(refAndPathName) {
        // $ref has to match prop in store
        return autocompleteTextButNoValue(this, refAndPathName, this.$store.get(`projects/searchWizard@query.${refAndPathName}`))
      },
      fieldNotValidError(field) {
        return autocompleteTextButNoValueMessage(field)
      },
      isSelectedProject(projectResult) {
        return this.selectedProject != null && projectResult._id === this.selectedProject.id
      },
      handleProjectSelect(projectResult) {
        if (projectResult) {
          if (projectResult._source.stopWork) {
            notifyWarning(this, 'Work has stopped on this project. No jobs can be added')
            return
          }
          projectResult._source.id = projectResult._id
          this.selectedProject = projectResult._source
          this.$store.commit('projects/edit/projectId', projectResult._id)
          this.$store.commit('projects/edit/details/all', this.selectedProject)
          this.$store.commit('projects/edit/address/all', this.selectedProject.address)
          this.$emit('projectSelected', projectResult._source)
        }
      },
      clearForm() {
        this.$validator.reset()
        this.$validator.pause()
        this.$store.commit('projects/searchWizard/resetQuery')
        this.$store.commit('projects/searchWizard/resetResults')
        this.$store.commit('wizard/nextDisabled', true)
        this.selectedProject = null
        if (!this.$store.get('projects/searchWizard@remember.city')) {
          this.$store.commit('address/cities', [])
          this.localCity = null
        }
        if (!this.$store.get('projects/searchWizard@remember.streetName')) {
            this.localStreetName = null
        }
        setTimeout(this.resumeValidation, 250)
      },
      resumeValidation() {
        this.$validator.resume()
      },
      maybeSearchSubmit() {
        if (this.$store.get('projects/searchWizard@query.city')
          && this.$store.get('projects/searchWizard@query.streetNumber')
          && this.$store.get('projects/searchWizard@query.streetName')) {
          this.searchSubmit()
        }
      },
      async searchSubmit() {
        if (await this.$validator.validateAll()) {
          const response = await this.$store.dispatch('projects/searchWizard/fetchElasticsearchResults')
          if (response.hits.total.value === 0) {
            this.$eventHub.$emit('show-modal-2', 'No Project Results Found', Constants.CREATE_PROJECT.FROM_PROJECT_SEARCH_WIZARD, '600px')
          }
          if (response.hits.total.value > Constants.ELASTICSEARCH.MAX_SEARCH_RESULTS) {
            maxResultsWarning(this, Constants.ELASTICSEARCH.MAX_SEARCH_RESULTS)
          }
        }
      },
      async findCities(text, cb) {
        await findCities(this, text, cb, 'projects/searchWizard/query@city')
      },
      setCityLoadCountiesZips(city) {
        if (this.$parent.$parent.tabs[0].active) {
          setCityLoadCountiesZips(this, city, 'projects/searchWizard/query@city')
          this.$validator.reset()
          this.maybeSearchSubmit()
        }
      },
      resetDependentAutocompleteFields() {
        this.counties = []
        this.zipCodes = []
        this.localStreetName = null
        this.$store.set('address/cities', [])
        this.$store.set('projects/searchWizard/query@city', null)
        this.$store.set('projects/searchWizard/query@county', null)
        this.$store.set('projects/searchWizard/query@zip', null)
      },
      verifyCityAutocompleteSelected() {
        if (this.localCity !== this.$store.get('projects/searchWizard/query@city')) {
          verifyAutocompleteSelected(this, 'projects/searchWizard@query.city', 'city', this.localCity)
          this.resetDependentAutocompleteFields()
        }
      },
      verifyCitySelected() {
        if (!this.localCity || !this.$store.get('projects/searchWizard/query@city')) {
          this.$eventHub.$emit('show-modal-6', 'No City Error', null, '500px')
        }
      },
      clearCity() {
        this.localCity = null
      },
      async findStreets(text, cb) {
        await findStreets(this, text, cb, 'projects/searchWizard/query@')
      },
      setStreet(street) {
        if (this.$parent.$parent.tabs[0].active) {
          this.localStreetName = street.name
          this.$store.set('projects/searchWizard/query@streetName', street.name)
          this.$validator.reset()

          this.maybeSearchSubmit()
        }
      },
      clearStreet() {
        this.localStreetName = null
      },
      verifyStreetAutocompleteSelected() {
        verifyAutocompleteSelected(this, 'projects/searchWizard@query.streetName', 'street name', this.localStreetName)
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      alsoRememberCity(value) {
        if (value) {
          this.$store.set('projects/searchWizard/remember@city', true)
        }
      },
      rememberCityChanged(value) {
        if (!value) {
          this.$store.set('projects/searchWizard/remember@county', false)
          this.$store.set('projects/searchWizard/remember@zip', false)
          this.$store.set('projects/searchWizard/remember@streetName', false)
        }
      },
      async maybeLoadRememberedAutocompleteLocalVars() {
        const vuexCity = this.$store.get('projects/searchWizard@query.city')
        if (vuexCity) {
          const response = await this.$store.dispatch('cities/fetchByName', vuexCity)
          if (OK === response.status) {
            this.localCity = vuexCity
            this.counties = kvpsForSelectFromArray(response.data.counties)
            this.zipCodes = kvpsForSelectFromArray(response.data.zipCodes)
          }
        }

        const vuexStreetName = this.$store.get('projects/searchWizard@query.streetName')
        if (vuexStreetName) {
          this.localStreetName = vuexStreetName
        }
      },
      callNumberInStringSort(a, b, prop) {
        return numberInStringSort(a, b, prop)
      },
      callStringSort(a, b, prop) {
        return stringSort(a, b, prop)
      },
    },
    mounted() {
      this.$eventHub.$on('citySaved', this.setCityLoadCountiesZips)
      this.$eventHub.$on('noCitySaved', this.clearCity)
      this.$eventHub.$on('streetSaved', this.setStreet)
      this.$eventHub.$on('noStreetSaved', this.clearStreet)
      // reset previous project edit
      this.$store.cache.dispatch('types/fetchByEntityType', 'Project')
      this.$store.commit('projects/edit/details/reset')
      this.$store.commit('projects/edit/address/reset')
      this.$store.commit('address/cities', [])
      this.$store.commit('address/streets', [])
      this.maybeLoadRememberedAutocompleteLocalVars()
    },
    destroyed() {
      this.$eventHub.$off('citySaved')
      this.$eventHub.$off('noCitySaved')
      this.$eventHub.$off('streetSaved')
      this.$eventHub.$off('noStreetSaved')
    },
    watch: {
      localCity: {
        handler: function (city) {
          if (!city) {
            this.resetDependentAutocompleteFields()
            this.$validator.reset()
          }
        }
      },
      localStreetName: {
        handler: function (streetName) {
          if (!streetName) {
            this.$store.set('projects/searchWizard/query@streetName', null)
            this.$validator.reset()
          }
        }
      }
    }
  }
</script>

<style scoped>
  .row label {
    display: block;
  }

  .advanced-search .row {
    margin-bottom: 10px;
  }

  .fix-search-container {
    clear: both;
    margin-bottom: 15px;
  }

  .card .card-footer .btn-clear {
    margin-right: 12px;
  }

  .btn-clear {
    margin-left: 12px;
  }
</style>
